import { Globe2, Truck, ShieldCheck, RotateCcw } from "lucide-react";
import { RETURNS_DAYS_DEFAULT, FREE_SHIPPING_OVER_CENTS_FALLBACK } from "@/lib/site-config";

export function AnnouncementBar() {
  const shipCopy = `Free shipping on orders over €${(FREE_SHIPPING_OVER_CENTS_FALLBACK / 100).toFixed(0)}`;
  const base = [
    { icon: Truck, text: shipCopy },
    { icon: RotateCcw, text: `${RETURNS_DAYS_DEFAULT}-day free returns — no questions asked` },
    { icon: Globe2, text: "Worldwide shipping — we ship to every country" },
    { icon: ShieldCheck, text: "Quality-matched parts, guarantee" },
  ];
  const items = [...base, ...base];
  return (
    <div className="sticky top-0 z-50 flex h-7 flex-col overflow-hidden border-b border-white/10 bg-ink text-paper sm:h-8">
      <div className="flex h-full animate-marquee items-center gap-6 whitespace-nowrap text-[11px] sm:gap-10 sm:text-sm">

        {[...items, ...items].map((it, i) => {
          const Icon = it.icon;
          return (
            <span key={i} className="flex shrink-0 items-center gap-1.5 sm:gap-2">
              <Icon className="h-3.5 w-3.5 text-sky-pop sm:h-4 sm:w-4" />
              <span className="font-medium tracking-wide">{it.text}</span>
              <span aria-hidden className="text-paper/60">•</span>
            </span>
          );
        })}
      </div>
    </div>
  );
}